<template>
  <div id="root" class="h-screens w-full relative overflow-hiddens">
    <router-view name="layout">
      <div class="content">
        <router-view name="content" :key="$route.fullPath" />
      </div>
    </router-view>
  </div>
</template>

<script>
import { appConfig } from '@src/app.config'
import ToastificationContent from '@components/plugins/toastification-content.vue'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.app.appName}` : appConfig.app.appName
    },
  },
  events: {
    showNotif(payloads) {
      this.$toast.clear();
      this.$toast({
        component: ToastificationContent,
        props: {
          title: payloads.title !== undefined && payloads.title !== '' ? payloads.title : (payloads.variant !== undefined && payloads.variant === 'success' ? 'Success!' : 'Failed!'),
          text: payloads.msg !== undefined ? payloads.msg : '',
          extra: payloads.extra !== undefined ? payloads.extra : [],
          icon: payloads.icon !== undefined ? payloads.icon : 'BellIcon',
          variant: payloads.variant !== undefined ? payloads.variant : 'success'
        }
      });
    }
  },
  mounted() {
    // this.initPerfectScrollbar('#root', {
    //   wheelPropagation: true,
    // })
  }
}
</script>

<style lang="scss">

// @import '@design/index.scss';
// @import '@design/icons.scss';

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';

// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

#nprogress {
  .spinner {
    @apply z-[99999];
  }
  .bar {
    @apply z-[99999] bg-theme-orange-01;
  }
  .spinner-icon {
    @apply z-[99999] border-t-theme-orange-01 border-l-theme-orange-01;
  }
}
</style>
